export const mergeStreetAndUnit = (street, unit) =>
  [unit, street].filter(Boolean).join(" - ");
